import React from "react";
import { Link } from "react-router-dom";

import { NewsItem } from "../../../../content/news";

import style from "./styles.module.scss";

export type NewsCardSize = "default" | "small";

const imageHeights: { [key in NewsCardSize]: number } = {
  default: 216,
  small: 76,
};

interface NewsCardProps {
  item: NewsItem;
  size?: NewsCardSize;
}

export default function NewsCard({ item, size = "default" }: NewsCardProps) {
  const { date, image, path, title } = item;

  return (
    <article className={`${style.card} ${size === "small" ? style.small : ""}`}>
      <img
        alt=""
        aria-hidden="true"
        className={style.image}
        decoding="async"
        height={imageHeights[size]}
        loading="lazy"
        src={image}
      />

      <div className={style.infos}>
        <span className={`pgm-body-small ${style.date}`}>{date}</span>
        <h2 className={`pgm-title-medium ${style.title}`}>
          <Link className={style.link} to={path}>
            {title}
          </Link>
        </h2>
      </div>
    </article>
  );
}
